export const TRIMS = [
    "LE",
    "SE",
    "XLE Premium",
    "Woodland",
    "XSE",
    "Limited",
];

export const TRIM_PRICING = [
    { model: "LE SUV", drivetrain: "FWD", msrp: 31900, invoice: 29987 },
    { model: "LE SUV", drivetrain: "AWD", msrp: 33300, invoice: 31303 },
    { model: "SE SUV", drivetrain: "FWD", msrp: 34700, invoice: 32619 },
    { model: "SE SUV", drivetrain: "AWD", msrp: 36100, invoice: 33935 },
    { model: "XLE Premium SUV", drivetrain: "FWD", msrp: 36100, invoice: 33935 },
    { model: "XLE Premium SUV", drivetrain: "AWD", msrp: 37500, invoice: 35251 },
    { model: "Woodland SUV", drivetrain: "AWD", msrp: 39900, invoice: 37507 },
    { model: "XSE SUV", drivetrain: "AWD", msrp: 41300, invoice: 38823 },
    { model: "Limited SUV", drivetrain: "AWD", msrp: 43300, invoice: 40703 },
];

export const COLORS = [
    "Meteor Shower",
    "Wind Chill Pearl",
    "Storm Cloud",
    "Midnight Black Metallic",
    "Ruby Flare Pearl",
    "Blueprint",
    "Ice Cap",
];

export const MEMBERSHIP_FEE = 399;

export const ZOOM_SCHEDULER_URL = "https://scheduler.zoom.us/david-einstein-aeif7w/30-mins-with-david";
export const FIO_OPTIONS = ["All Wheel Drive", "Panoramic Moonroof Package"];

export const DRIVETRAINS = ["All Wheel Drive (AWD)", "Front Wheel Drive (FWD)"];

export const MOONROOF_OPTIONS = [
    "Panoramic Moonroof Package",
    "Standard Moonroof",
    "No Moonroof",
];
